import { useState, useSyncExternalStore } from "react";
import {
  applyPwaUpdate,
  dismissPwaNotice,
  getPwaSnapshot,
  subscribePwa,
} from "./pwa";

export function PwaStatus() {
  const [updating, setUpdating] = useState(false);
  const status = useSyncExternalStore(
    subscribePwa,
    getPwaSnapshot,
    getPwaSnapshot,
  );

  if (!status.offlineReady && !status.updateAvailable && !status.registrationError) {
    return null;
  }

  return (
    <aside
      className="ui-card ui-stack pwa-status"
      aria-live="polite"
      aria-atomic="true"
    >
      {status.updateAvailable ? (
        <>
          <p>学习中心有新版本。请先保存当前输入，再更新。</p>
          <div className="pwa-status__actions">
            <button
              className="ui-button"
              data-variant="primary"
              disabled={updating}
              type="button"
              onClick={() => {
                setUpdating(true);
                void applyPwaUpdate().then((applied) => {
                  if (!applied) setUpdating(false);
                });
              }}
            >
              {updating ? "正在更新…" : "保存后更新"}
            </button>
            <button
              className="ui-button"
              data-variant="ghost"
              type="button"
              onClick={dismissPwaNotice}
            >
              稍后
            </button>
          </div>
        </>
      ) : null}
      {status.offlineReady ? <p>离线资源已就绪。</p> : null}
      {status.registrationError ? <p>{status.registrationError}</p> : null}
      {!status.updateAvailable ? (
        <button
          className="ui-button"
          data-variant="ghost"
          type="button"
          onClick={dismissPwaNotice}
        >
          关闭提示
        </button>
      ) : null}
    </aside>
  );
}
